import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ShopItem from './ShopItem.vue';
export default {
  name: "ShoppingCard",
  data: function data() {
    return {
      cartVisibility: false
    };
  },
  computed: {
    shoppingCardProductsCount: function shoppingCardProductsCount() {
      var count = 0;
      this.shoppingCardInfo.products.forEach(function (item) {
        count += item.unit;
      });
      return count;
    }
  },
  props: {
    shoppingCardInfo: {
      required: true,
      type: Object
    }
  },
  components: {
    ShopItem: ShopItem
  },
  methods: {
    toggleCartVisibility: function toggleCartVisibility() {
      this.cartVisibility = !this.cartVisibility;
    }
  }
};